import { motion } from 'framer-motion';
import { BadgeCheck, Building2, Globe2, TrendingUp, Waypoints } from 'lucide-react';

export default function StatsStrip({ stats, selectedCountry }) {
  if (!stats) return null;

  const items = selectedCountry
    ? [
        { label: 'Leaderboard Size', value: stats.current_view_count, icon: Building2, testid: 'stats-total-companies', accent: '#3498DB' },
        { label: 'Average ESG', value: stats.average_score, suffix: '/100', icon: TrendingUp, testid: 'stats-average-score', accent: '#2A9D8F' },
        { label: 'Validated', value: stats.validated_count, icon: BadgeCheck, testid: 'stats-validated-count', accent: '#4ECDC4' },
        { label: 'Markets Covered', value: stats.total_countries, icon: Globe2, testid: 'stats-total-countries', accent: '#D8B45A' },
      ]
    : [
        { label: 'Country Views Tracked', value: stats.total_companies, icon: Building2, testid: 'stats-total-companies', accent: '#3498DB' },
        { label: 'GP Markets', value: stats.total_countries, icon: Waypoints, testid: 'stats-total-countries', accent: '#D8B45A' },
        { label: 'Average ESG', value: stats.average_score, suffix: '/100', icon: TrendingUp, testid: 'stats-average-score', accent: '#2A9D8F' },
        { label: 'Validated Entries', value: stats.validated_count, icon: BadgeCheck, testid: 'stats-validated-count', accent: '#4ECDC4' },
      ];

  return (
    <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4" data-testid="stats-strip">
      {items.map((item, index) => (
        <motion.div
          key={item.label}
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.06, duration: 0.28 }}
          className="rounded-2xl border border-white/10 bg-[rgba(13,34,56,0.88)] p-4 shadow-[0_10px_30px_rgba(0,0,0,0.32)] [box-shadow:inset_0_1px_0_rgba(231,237,245,0.06)]"
          data-testid={item.testid}
        >
          <div className="mb-3 flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-xl" style={{ backgroundColor: `${item.accent}22` }}>
              <item.icon className="h-4 w-4" style={{ color: item.accent }} />
            </span>
            <div>
              <p className="text-[11px] uppercase tracking-[0.16em] text-white/40">{item.label}</p>
              <p className="text-xs text-white/30">{selectedCountry ? selectedCountry : 'Cross-market benchmark'}</p>
            </div>
          </div>
          <p className="font-mono text-3xl font-bold text-white tabular-nums">
            {item.value}
            {item.suffix ? <span className="ml-1 text-sm text-white/40">{item.suffix}</span> : null}
          </p>
        </motion.div>
      ))}
    </div>
  );
}
